import { ColumnsType } from "antd/es/table";
import {
  getColumnsParamsType,
  NotesTableDataResponseType,
} from "../../../Types/DatabaseTabTypes";
import * as Yup from "yup";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { EllipsisOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { PlacementPositions } from "../../../enums/PlacementPositionsEnums";
import styles from "./NotesTable.module.scss";
import { DatabaseSections } from "../../../enums/DatabaseEnums";
import { ArchiveId, ArchiveKeys } from "../../../enums/ArchiveActionKeys";
import DescriptionCell from "../../../reusable-components/DescriptionCell";
import ConditionalRender from "../../../reusable-components/ConditionalRender";

export const reservedNotesKey = "Job Creation Note";

export const getColumns = (
  params?: getColumnsParamsType
): ColumnsType<NotesTableDataResponseType> => [
  {
    title: "TYPE",
    key: "type",
    align: "center",
    dataIndex: "typeofNotes",
    render: (val) => <span className="table-font-mobile">{val}</span>,
  },
  {
    title: "NOTE",
    key: "notes",
    align: "center",
    dataIndex: "notes",
    render: (val) => <span className="table-font-mobile"><DescriptionCell text={val} /></span>,
  },
  {
    title: "UPLOAD DATE",
    key: "uploadDate",
    align: "center",
    dataIndex: "date",
    render: (val, record) => (
      <span className="table-font-mobile">
        {val} {record?.time}
      </span>
    ),
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    align: "right",
    render: (_, record) => {
      return (
       <ConditionalRender
        visible={
          !!!params?.blockedJob
          && record?.typeofNotes !== reservedNotesKey
        }
       >
        <Popover
          placement={PlacementPositions.LEFT}
          content={
            <>
              <div
                className={styles.PopoverContent}
                onClick={() => params?.handleEditNavigate(record?.id)}
              >
                <MdModeEdit />
                Edit
              </div>
              <div
                className={styles.PopoverContent}
                onClick={() => params?.handleDeleteModalOpen(record?.id)}
              >
                <MdDelete />
                Delete
              </div>
            </>
          }
        >
          <EllipsisOutlined
            style={{ padding: "0.5rem", fontSize: "30px", color: "#C3C8CD" }}
            className="action-ellipsis-button"
          />
        </Popover>
      </ConditionalRender> 
      );
    },
  },
];

export const NotesTableConstants = {
  BUTTON: {
    ADD_NOTES_LABEL: "+ Add Notes",
  },
  MODAL: {
    ADD_NOTES_MODAL_TITLE: "Add Notes",
    SUBMIT_BUTTON_LABEL: "Submit",
    WIDTH: "716px",
    DELETE_NOTES_MODAL_TITLE: "Delete Note",
    DELETE_NOTE_CONTENT:
      "This note will be permanently deleted. Are you sure you want to proceed?",
    CONFIRM_DELETE_LABEL: "Confirm",
    EDIT_NOTES_MODAL_TITLE: "Edit Notes",
  },
  MESSAGES: {
    ADD_NOTES_SUCCESSFUL: "Notes added successfully!",
    ADD_NOTES_ERROR: "Failed to add notes!",
    DELETE_NOTE_SUCCESSFUL: "Notes deleted successfully!",
    DELETE_NOTE_ERROR: "Failed to delete notes!",
    EDIT_NOTE_SUCCESSFUL: "Notes updated successfully!",
    EDIT_NOTE_ERROR: "Failed to update notes!",
  },
};

export const NotesValidationSchema = Yup.object().shape({
  typeofNotes: Yup.string().required("Notes type is required!"),
  notes: Yup.string()
    .required("Notes is required!")
    .max(500, "Max character length is 500!"),
});

export const notesDeletedTableMap = {
  [DatabaseSections.QUARRY]: ArchiveKeys.QUARRY_NOTES,
  [DatabaseSections.JOBS]: ArchiveKeys.JOB_NOTES,
  [DatabaseSections.CUSTOMER]: ArchiveKeys.CUSTOMER_NOTES,
};

export const notesIdMap = {
  [DatabaseSections.QUARRY]: ArchiveId.QUARRY_ID,
  [DatabaseSections.CUSTOMER]: ArchiveId.COMPANY_ID,
};
